import { getRequest } from '../services/requestHandler';
import { BsgShoeWidth } from '../models';

// Model: TourApp.Data/Models/PlayerRegionLookup
export const getBsgShoeWidth = async () => {
  const url = 'bsgshoe/getBsgShoeWidth?activeOnly=true';
  const response = await getRequest<BsgShoeWidth>('GetBsgShoeWidth', url);
  return response;
};
